import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown";
import { cn } from "@/lib/utils";
import { TrashIcon } from "@heroicons/react/outline";
import { CopyIcon } from "@radix-ui/react-icons";
import { Maximize2, MoreVerticalIcon } from "lucide-react";

interface MessageActionsProps {
  onCopy: () => void;
  onMaximize: () => void;
  onDelete: () => void;
  disabled?: boolean;
  readonly?: boolean;
  className?: string;
}

/**
 * MessageActions component provides a dropdown menu with actions for a message.
 * Consolidates copy, maximize, and delete actions into a clean vertical dots menu.
 */
const MessageActions = ({
  onCopy,
  onMaximize,
  onDelete,
  disabled = false,
  readonly = false,
  className,
}: MessageActionsProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="tinyIcon"
          disabled={disabled}
          className={cn("h-8 w-8 p-0", className)}
        >
          <MoreVerticalIcon className="h-4 w-4" />
          <span className="sr-only">Message actions</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuItem onSelect={onCopy}>
          <CopyIcon className="h-4 w-4" />
          Copy
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={onMaximize}>
          <Maximize2 className=" h-4 w-4" />
          Maximize
        </DropdownMenuItem>
        {!readonly && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onSelect={onDelete}
              className="text-red-600 focus:text-red-600"
            >
              <TrashIcon className=" h-4 w-4" />
              Delete
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MessageActions;
